import * as React from 'react';
import { ImageBlockContent } from '../../../../commonv3/types/block';
import { BlockDescription } from '../../atoms/blocks/BlockDescription';
import { BlockImage } from '../../atoms/blocks/BlockImage';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {
  content: ImageBlockContent;
};

export const ImageBlockContentPane = observer(
  class ImageBlockContentPane extends React.Component<Props> {
    render() {
      const { content } = this.props;
      return (
        <div>
          {GlobalStatesV3.viewport.isMobile && <BlockImage imageRef={content.imageRef} />}
          <BlockDescription content={content.description} />
          {GlobalStatesV3.viewport.isDesktop && <BlockImage imageRef={content.imageRef} />}
        </div>
      );
    }
  }
);
